import { render } from "./SystemPage.vue?vue&type=template&id=5cd661d4&scoped=true&lang=pug"
import script from "./SystemPage.vue?vue&type=script&lang=js"
export * from "./SystemPage.vue?vue&type=script&lang=js"

import "./SystemPage.vue?vue&type=style&index=0&id=5cd661d4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5cd661d4"

export default script